import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { media } from '../../utils/media-queries';

const Value = ({ headline, description, number, variants }) => (
  <StyledValue variants={variants}>
    <p className="headline">{headline}</p>
    <p className="number">{`${number < 10 ? '0' : ''}${number}`}</p>
    <p className="description">{description}</p>
  </StyledValue>
);

const StyledValue = styled(motion.div)`
  width: 50%;
  padding-top: var(--sp-5);

  .number {
    color: var(--red-light);
    font-size: 12rem;
    line-height: 0.8;
    font-weight: 500;
    padding-left: var(--sp-1);
  }

  .headline {
    color: var(--red);
    padding-bottom: var(--sp-0);
    transform: translateY(var(--sp-8));
  }

  .description {
    width: 90%;
    font-size: var(--fs-small);
  }

  @media ${media.M} {
    width: 31%;

    .number {
      padding-left: var(--sp-2);
    }
  }

  @media ${media.XL} {
    .description {
      width: 60%;
    }
  }
`;

Value.propTypes = {
  headline: PropTypes.string,
  description: PropTypes.string,
  number: PropTypes.number,
  variants: PropTypes.object,
};

export default Value;
